(() => {
  const ACTIVE_LINE_GAP = 24;

  function headerHeight() {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(value) || 0;
  }

  function initKitRoot(root) {
    const nav = root.querySelector('[data-kit-jump]');
    if (!nav || root.dataset.kitReady) return;
    root.dataset.kitReady = 'true';

    const list = nav.querySelector('.kit-jump__list') || nav;
    const links = Array.from(nav.querySelectorAll('a[href^="#kits-"]'));
    const entries = links
      .map((link) => {
        const heading = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        const group = heading && heading.closest('[data-aperture]');
        return group ? { link, group } : null;
      })
      .filter(Boolean);
    if (!entries.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = null;
    let frame = 0;

    const setJumpHeight = () => {
      const height = `${nav.offsetHeight}px`;
      root.style.setProperty('--kit-jump-height', height);
      document.documentElement.style.setProperty('--kit-jump-height', height);
    };

    const updateFade = () => {
      const max = list.scrollWidth - list.clientWidth;
      const atStart = list.scrollLeft <= 1;
      const atEnd = list.scrollLeft >= max - 1;
      let fade = '';
      if (max > 1) fade = atStart ? 'end' : atEnd ? 'start' : 'both';
      if (fade) list.dataset.fade = fade;
      else delete list.dataset.fade;
    };

    const revealChip = (link) => {
      if (list.scrollWidth <= list.clientWidth) return;
      const target = link.offsetLeft - (list.clientWidth - link.offsetWidth) / 2;
      const left = Math.max(0, Math.min(target, list.scrollWidth - list.clientWidth));
      list.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };

    const setActive = (entry) => {
      if (entry === current) return;
      if (current) current.link.removeAttribute('aria-current');
      current = entry;
      if (!entry) return;
      entry.link.setAttribute('aria-current', 'location');
      revealChip(entry.link);
    };

    const update = () => {
      frame = 0;
      const line = headerHeight() + nav.offsetHeight + ACTIVE_LINE_GAP;
      const active = entries.find((entry) => {
        const rect = entry.group.getBoundingClientRect();
        return rect.top <= line && rect.bottom > line;
      });
      setActive(active || null);
      if (!active && list.scrollLeft > 0 && entries[0].group.getBoundingClientRect().top > line) {
        list.scrollTo({ left: 0 });
      }
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    setJumpHeight();
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => {
        setJumpHeight();
        updateFade();
        schedule();
      }).observe(nav);
    }

    if ('IntersectionObserver' in window) {
      const thresholds = Array.from({ length: 21 }, (_, i) => i / 20);
      const observer = new IntersectionObserver(schedule, { threshold: thresholds });
      entries.forEach((entry) => observer.observe(entry.group));
    }
    window.addEventListener('scroll', schedule, { passive: true });
    list.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', schedule);
    links.forEach((link) => {
      link.addEventListener('click', () => {
        const entry = entries.find((item) => item.link === link);
        if (entry) setActive(entry);
      });
    });
    updateFade();
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-kit-root]').forEach(initKitRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
